// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__ULQEx","green":"Badge_green__PRkKp","red":"Badge_red__VWPVF","yellow":"Badge_yellow__b-hfJ","gray":"Badge_gray__iZskY"};